export const EMPLOYMENT_TYPE_WORK_VISA = 1
export const EMPLOYMENT_TYPE_SEASON_VISA = 2
export const EMPLOYMENT_TYPE_BIOMETRIC = 3
export const EMPLOYMENT_TYPE_CUSTOM = 4

export const STEP_EMPLOYMENT_TYPE = 0
export const STEP_BUYING_INSURANCE = 1
export const STEP_CHECK_INSURANCE = 2
export const STEP_STATEMENT_FORM = 3
export const STEP_ARRIVAL = 4
export const STEP_EMPLOYMENT_OFFER_ACCEPT = 5
export const STEP_BUY_TICKETS = 6
export const STEP_CHECK_TICKETS = 7
export const STEP_CONFIRM_ARRIVAL = 8
export const STEP_CONTRACT = 9
export const STEP_SEND_REVIEW = 10
export const STEP_END = 11
export const STEP_PAY_SERVICE_FEE = 12
export const STEP_SELECT_VISA_OPTIONS = 13
export const STEP_VISA_CENTER_VISIT_DATA = 14
export const STEP_UPLOAD_VISA = 15
export const STEP_CHECK_VISA = 16
export const STEP_VISA_CREATION_FORM = 17
export const STEP_WITH_TRANSFER = 18
export const STEP_ARRIVAL_INFO_SHOW = 19
export const STEP_VISA_INFO_SHOW = 20
export const STEP_VISA_INFO_SHOW_BIOMETRIC = 21
export const STEP_REQUIREMENTS = 22
export const STEP_REQUIREMENTS_ANSWER = 23
export const STEP_REQUIREMENTS_CHECK = 24
export const STEP_UPLOAD_INVITATION = 25
export const STEP_WELCOME_VISA = 26
export const STEP_WELCOME_BIOMETRIC = 27
export const STEP_RECEIPT_CHECK = 28
export const STEP_DOCUMENTS_SENT_WAITING = 29
export const STEP_CUSTOM_WELCOME = 30
export const STEP_CUSTOM_INSURANCE = 31
export const STEP_CUSTOM_VISA = 32
export const STEP_CUSTOM_TICKETS = 33
export const STEP_CUSTOM_CONTRACT = 34
export const STEP_VISA_SENDING_TYPE = 35
